import * as _ from "lodash";
import * as angular from "angular";
import { CanvassStatus } from "../../models/canvass-status.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { PermissionCheck } from "../../shared/permission";

let CanvassStatusForm = {
    selector: "vcCanvassStatusForm",
    templateUrl:
        "/angular/components/canvass-status/canvass-status-form.component.html",
    bindings: {
        selectedStatus: "=?",
        mode: "=?",
    },
    controller: class CanvassStatusFormController {
        // * bindings for typescript compiler *
        public selectedStatus?: any;
        public mode?: string;
        // ************************************

        private dataProvider: CanvassStatusDataProvider;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        public permissionProvider: PermissionCheck;
        public saving: boolean;
        public status: CanvassStatus;
        public colors: any[];
        public hasNationbuilder: boolean = false;
        public nbstatuses: any[] = [];

        constructor(
            DialogUtils: DialogUtils,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck
        ) {
            this.dataProvider = CanvassStatusDataProvider;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.colors = new CanvassStatus().colors;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            this.status = _.cloneDeep(this.selectedStatus);
        }

        saveStatus(status: CanvassStatus): void {
            this.saving = true;
            if (status.id) {
                this.dataProvider.update(status).then(
                    (status) => {
                        this.selectedStatus.setData(this.status);
                        this.dialog.hide(status);
                    },
                    (error) => {
                        this.saving = false;
                        console.log(error);
                    }
                );
            } else {
                this.dataProvider.create(status).then(
                    (status) => {
                        this.dialog.hide(status);
                        this.toast.success("Interaction Status created");
                    },
                    (error) => {
                        this.saving = false;
                        console.log(error);
                    }
                );
            }
        }

        selectColor(color: any): void {
            this.status.color = color.hex;
        }

        ok(): void {
            this.saveStatus(this.status);
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("canvassStatus", [])
    .component(CanvassStatusForm.selector, CanvassStatusForm);
